// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__22G8Y","large":"styles_large__3q1qV"};